import React from 'react';
import { Home, Building2, Leaf } from 'lucide-react';
import { commonStyles } from '../../styles/common';
import BenefitCard from './BenefitCard';
import { benefitsData } from '../../data/cee';

const Benefits = () => {
  return (
    <section className={`${commonStyles.section} bg-gray-50`}>
      <div className={commonStyles.container}>
        <h2 className={commonStyles.heading.primary}>Pourquoi les CEE sont importants pour vous ?</h2>
        
        <div className="grid md:grid-cols-2 gap-8 mt-8">
          <div>
            <h3 className="text-xl font-semibold mb-6 flex items-center">
              <Home className="w-6 h-6 text-blue-600 mr-2" />
              Pour les particuliers
            </h3>
            <div className="space-y-4">
              {benefitsData.particuliers.map((benefit) => (
                <BenefitCard key={benefit.title} {...benefit} />
              ))}
            </div>
          </div>
          
          <div>
            <h3 className="text-xl font-semibold mb-6 flex items-center">
              <Building2 className="w-6 h-6 text-blue-600 mr-2" />
              Pour les entreprises
            </h3>
            <div className="space-y-4">
              {benefitsData.entreprises.map((benefit) => (
                <BenefitCard key={benefit.title} {...benefit} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;